import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';

interface ILayoutSidebarProps {
  content: ReactNode;
  sidebar: ReactNode;
}

const Layout = styled.div<Partial<ILayoutSidebarProps>>`
  position: relative;
  display: flex;
  flex: 1;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;

  @media (min-width: ${theme.breakpoint.large}px) {
    flex-flow: row nowrap;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
  }
`;

const Content = styled.section`
  position: relative;
  display: flex;
  flex-grow: 1;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: auto;
  padding-bottom: ${toRem(theme.header.height)};

  @media (min-width: ${theme.breakpoint.large}px) {
    padding-right: ${toRem(theme.sidebar.width.large)};
    padding-bottom: 0;
  }

  @media (min-width: ${theme.breakpoint.xlarge}px) {
    padding-right: ${toRem(theme.sidebar.width.xlarge)};
  }
`;

const LayoutSidebar = ({ content, sidebar, ...rest }: ILayoutSidebarProps) => (
  <Layout {...rest}>
    <Content>{content}</Content>
    {sidebar}
  </Layout>
);

export default LayoutSidebar;
